// extracted by mini-css-extract-plugin
export default {"container":"PublishingDetail_container__0LDFH","firstSectionBox":"PublishingDetail_firstSectionBox__uhCDL"};